import { render, staticRenderFns } from "./BusinessDataDetails.vue?vue&type=template&id=4258c1e1&scoped=true&"
import script from "./BusinessDataDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessDataDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDataDetails.vue?vue&type=style&index=0&id=4258c1e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4258c1e1",
  null
  
)

export default component.exports